import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './lib/knowledgeNavigation';
import ErrorToast from './components/ErrorToast';
import { initTheme } from './lib/theme';
import './styles.css';
import './pages/Meetings.css';

initTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ErrorToast />
      <App />
    </BrowserRouter>
  </StrictMode>,
);
